import React from 'react';

import BiopharmaGroupsLoader from './BiopharmaGroupsLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import BiopharmaGroupsFilterOptions from './BiopharmaGroupsFilterOptions';
import BiopharmaGroupsTable from './BiopharmaGroupsTable';
import BiopharmaGroupsPageController from './BiopharmaGroupsPageController';
import styles from './BiopharmaGroups.module.scss';

const BiopharmaGroups = () => {
  return (
    <>
      <BiopharmaGroupsLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Biopharma Groups'} />
          <BiopharmaGroupsFilterOptions />
          <BiopharmaGroupsTable />
          <BiopharmaGroupsPageController />
        </Stack>
      </div>
    </>
  );
};

export default BiopharmaGroups;
